import { DateRange } from './date';
import {Location} from './locations';
import { Merchants } from './merchant';

export class Terminal {
    id: number;
    code: number;
    name: number;
    location: Location;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}

export class TerminalSearch {
    createdDate: DateRange = DateRange.empty();
    name = '';
    code = '';
    merchantId = '';
    locationId = '';
    tId = '';
    status = 'All'
    field: 'name' | 'code' = 'name';
    value: '';
 }